import './index.scss';

const blockFaqContact = () => {
	
};

export default blockFaqContact;
